<template>
	<div>
		<div class="d-flex flex-column m-2">
			<div
				v-b-popover.hover.bottom="'Close'"
				@click="
					type == 'autopreview'
						? closeautopreview()
						: type == 'archivePreview'
						? toggleTestPreview()
						: closepreview()
				"
				class="x-markcancel-prev"
			>
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<div>
				<div class="testconfighead">Test Preview</div>
				<div class="tsconfigtext" v-if="type == 'preview'">
					{{ testConfigData.name }}
				</div>
				<div class="tsconfigtext" v-else>{{ testDetails.testName }}</div>
				<hr />
			</div>

			<b-overlay :show="showSpinner" rounded="sm">
				<div class="testPreviewContainer" id="top1">
					<template v-if="type == 'preview' || type == 'archivePreview'">
						<template v-if="sectionDetails.length == 0">
							<div class="d-flex preview-text align-items-center">
								<img src="../../assets/icons/testconfig/nodata.svg" alt="" />
								<div class="testconfignodata ml-2">No preview available</div>
							</div>
						</template>
						<template v-else>
							<div
								v-for="(i, index) in sectionDetails"
								:key="i.sectionID"
								@click="
									roles.includes('GET_QUESTION') && i.numberOfQuestions
										? sectionSelect(index)
										: ''
								"
							>
								<div
									:class="[
										'lmn' + i.sectionID,
										i.numberOfQuestions == 0 || i.secMarks == 0
											? 'my-div'
											: 'normal-div',
									]"
									class="tp-testconfigs-container accordion pointer d-flex"
									:style="
										index == 0
											? 'margin: 0px 0px 10px 0px;'
											: 'margin: 10px 0px 10px 0px;'
									"
									v-b-toggle="'mn' + i.sectionID"
								>
									<div style="width: 95%" class="d-flex align-items-center">
										<div style="width: 35%">
											<div
												class="testconfig-btns"
												v-if="i.name.length > 24"
												:id="i.sectionID"
											>
												{{ i.name | topicNameFilter }}
											</div>
											<div class="testconfig-btns" v-if="i.name.length < 24">
												{{ i.name }}
											</div>
											<span>
												<b-popover
													:id="accId"
													:target="i.sectionID"
													triggers="hover"
													placement="bottomright"
												>
													<span>{{ i.name }} </span>
												</b-popover>
											</span>
										</div>
										<div class="d-flex align-items-center" style="width: 65%">
											<div style="width: 120px">
												<span class="test-sec-marktext">Marks :</span>
												<span
													v-if="i.secMarks < 10"
													class="greennumbertext ml-1 mr-3"
													>0{{ i.secMarks }}</span
												>
												<span v-else class="greennumbertext ml-1 mr-3">{{
													i.secMarks
												}}</span>
											</div>
											<div>
												<span class="test-sec-marktext">Questions :</span>
												<span
													v-if="i.numberOfQuestions < 10"
													class="bluenumbertext ml-1 mr-3"
													>0{{ i.numberOfQuestions }}</span
												>
												<span v-else class="bluenumbertext ml-1 mr-3">{{
													i.numberOfQuestions
												}}</span>
											</div>
										</div>
									</div>
									<div style="width: 5%" class="when-closed">
										<img src="../../assets/downarrow.svg" alt="" />
									</div>
									<div style="width: 5%" class="when-open">
										<img src="../../assets/uparrow-preview.svg" alt="" />
									</div>
								</div>
								<b-collapse
									:id="'mn' + i.sectionID"
									accordion="my-accordion"
									role="tabpanel"
									class="topcard"
								>
									<b-overlay
										:show="showLoader"
										variant="white"
										:opacity="overlayOpacity"
										:blur="overlayBlur"
										rounded="sm"
									>
										<b-card-body class="test-pr-card" @click.stop>
											<AnswerCards :typeans="type" />
										</b-card-body>
									</b-overlay>
								</b-collapse>
							</div>
						</template>
					</template>

					<template v-else>
						<template v-if="autoSectionDetails.length == 0">
							<div class="d-flex preview-text align-items-center">
								<img src="../../assets/icons/testconfig/nodata.svg" alt="" />
								<div class="testconfignodata ml-2">No data available</div>
							</div>
						</template>
						<template v-else>
							<div
								v-for="i in autoSectionDetails"
								:key="i.sectionID"
								@click="autosectionSelect(i.sectionID)"
							>
								<div
									v-b-toggle="'mn' + i.sectionID"
									:class="
										i.numberOfQuestions == 0 || i.secMarks == 0
											? 'my-div'
											: 'normal-div'
									"
									class="testconfigs-container accordion d-flex"
								>
									<div class="d-flex align-items-center" style="width: 95%">
										<div style="width: 35%">
											<div
												class="testconfig-btns"
												v-if="i.name.length > 24"
												:id="i.sectionID"
											>
												{{ i.name | topicNameFilter }}
											</div>
											<div class="testconfig-btns" v-if="i.name.length < 24">
												{{ i.name }}
											</div>
											<span>
												<b-popover
													:target="i.sectionID"
													triggers="hover"
													placement="bottomright"
												>
													<span>{{ i.name }} </span>
												</b-popover>
											</span>
										</div>
										<div class="d-flex align-items-center" style="width: 65%">
											<div
												class="d-flex align-items-center"
												style="width: 120px"
											>
												<span class="test-sec-marktext">Marks :</span>
												<span
													v-if="i.secMarks < 10"
													class="greennumbertext ml-1 mr-3"
													>0{{ i.secMarks }}</span
												>
												<span v-else class="greennumbertext ml-1 mr-3">{{
													i.secMarks
												}}</span>
											</div>
											<div>
												<span class="test-sec-marktext">Questions :</span>
												<span
													v-if="i.numberOfQuestions < 10"
													class="bluenumbertext ml-1 mr-3"
													>0{{ i.numberOfQuestions }}</span
												>
												<span v-else class="bluenumbertext ml-1 mr-3">{{
													i.numberOfQuestions
												}}</span>
											</div>
										</div>
									</div>
									<div style="width: 5%" class="when-closed">
										<img src="../../assets/downarrow.svg" alt="" />
									</div>
									<div style="width: 5%" class="when-open">
										<img src="../../assets/uparrow-preview.svg" alt="" />
									</div>
								</div>
								<b-collapse
									:id="'mn' + i.sectionID"
									accordion="my-accordion"
									role="tabpanel"
									class="topcard"
								>
									<b-card-body class="test-pr-card">
										<AnswerCards :typeans="type" />
									</b-card-body>
								</b-collapse>
							</div>
						</template>
					</template>
				</div>
			</b-overlay>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import AnswerCards from "../AnswerCards.vue";

export default {
	name: "TestPreview",
	components: {
		AnswerCards,
	},
	props: {
		type: String,
	},
	data() {
		return {
			firstClick: true,
			accId: "mn",
			divid: "",
			showLoader: false,
			overlayBlur: "4",
			overlayOpacity: 0.46,
		};
	},

	computed: {
		...mapGetters("sectionVUEX", {
			sectionDetails: "getSectionDetails",
			selectedSectionData: "getSelectedSection",
		}),
		...mapGetters("testVUEX", {
			testConfigData: "getTestConfigData",
			showTestPreviewStatus: "getShowTestPreviewStatus",
			showSpinner: "getPreviewLoading",
		}),
		...mapGetters("autotestVUEX", {
			autoSectionDetails: "getAutoSectionDetails",
			testDetails: "getAutoSelectedTest",
		}),
		...mapGetters("topicVUEX", {
			selectedTopic: "getSelectedTopic",
		}),
		...mapGetters(["roles"]),
	},

	methods: {
		stayhere(id) {
			if (this.roles.includes("GET_QUESTION")) {
				this.accId = "mn" + id;
				this.divid = "lmn" + id;

				setTimeout(() => {
					this.$nextTick(() => {
						document.querySelector(`.${this.divid}`).scrollIntoView({
							behavior: "smooth",
							inline: "end",
						});
					});
				}, 1000);
			}
		},
		toggleTestPreview() {
			this.$emit("toggleTestPreview", false);
			this.$emit("toggleview", "view", null);
		},
		async sectionSelect(index) {
			if (this.roles.includes("GET_QUESTION")) {
				this.firstClick = false;
				this.showLoader = true;
				await this.$store.dispatch(
					"questionVUEX/getQuestions",
					this.sectionDetails[index]
				);
				this.showLoader = false;
			}
		},
		autosectionSelect(selectedSection) {
			this.firstClick = false;
			for (let i in this.autoSectionDetails) {
				if (this.autoSectionDetails[i].sectionID == selectedSection) {
					this.$store.commit(
						"autotestVUEX/saveSelectedSectionQuestion",
						this.autoSectionDetails[i].questions
					);
				}
			}
		},
		closepreview() {
			let showPreviewTest = false;

			this.$store.commit("testVUEX/saveshowPreviewTest", {
				preview_status: showPreviewTest,
			});

			this.$store.dispatch("sectionVUEX/getSection", this.testDetails.testID);
		},
		closeautopreview() {
			let showPreviewTest = false;
			this.$store.commit("autotestVUEX/saveshowPreviewTest", {
				preview_status: showPreviewTest,
			});
		},
	},
};
</script>

<style scoped>
.testPreviewContainer {
	height: calc(100vh - 260px);
	overflow-y: auto;
	overflow-x: hidden;
	padding-left: 10px;
	padding-right: 10px;
}

.x-markcancel-prev {
	position: absolute;
	top: 10px;
	right: 10px;
	border-radius: 50px;
	height: 20px;
	width: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: var(--btn-border);
	cursor: pointer;
}

.my-div {
	pointer-events: none;
}

.normal-div {
	pointer-events: visible;
}

.text-dos {
	height: 406px;
	overflow-y: auto;
}

.k-card {
	height: 480px;
}

.previewConText {
	position: fixed;
	top: 220px;
	font-weight: 400;
	color: #707070;
	width: 36vw;
	padding: 5px 0px;
	z-index: 3;
	font-size: 18px;
}

.marks {
	right: 0;
	position: absolute;
	top: 10px;
	color: #4a4a4a;
	font-weight: 300;
	font-size: 12px;
}

.mark1 {
	margin-right: 5px;
	margin-left: 5px;
}

.section-btn {
	width: 100px;
	height: 30px;
	font-size: 16px;
	font-weight: 400;
	display: flex;
	align-items: center;
	justify-content: center;
	border-color: #a2a2a2;
	color: #4b4d4e;
}

.section-btn-container {
	padding: 0px 5px 20px 0px;
	display: flex;
	top: 270px;
}

.btn-outline-danger:focus,
.btn-outline-danger.focus {
	box-shadow: none !important;
}

.btn:focus,
.btn.focus {
	outline: 0;
	box-shadow: none !important;
}

.add-section-btn {
	background-color: #ffffff;
	padding-left: 15px;
	width: 130px;
	height: 30px;
	margin-right: 15px;
	font-weight: 500;
	border-color: #a2a2a2;
	color: #a2a2a2;
	margin-bottom: 7px;
	padding-top: 2px;
}

.add-section-btn:focus {
	background-color: #c92b2b;
	border-color: transparent;
	color: #ffffff;
}

.add-section-btn:hover {
	background-color: #c92b2b;
	border-color: transparent;
	color: #ffffff;
}

.section-button-content {
	display: inline-block;
	width: 100px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.section-container {
	height: 60px;
	width: 100%;
	margin-top: 10px;
}

.section-filling-row {
	margin-left: 0px !important;
	display: flex;
	height: 100%;
	width: 100%;
	overflow-y: hidden;
	overflow-x: auto;
	white-space: nowrap;
	align-items: center !important;
}

.section-second-row {
	flex-wrap: nowrap !important;
}

.container-fluid {
	padding-right: 0px !important;
	padding-left: 0px !important;
	margin-right: auto;
	margin-left: auto;
}

@media only screen and (max-width: 1920px) {
	.text-dos {
		height: 585px;
	}

	.previewConText {
		width: 38vw;
	}
}

@media only screen and (max-width: 1710px) {
	.text-dos {
		height: 490px;
	}
}

@media only screen and (max-width: 1536px) {
	.text-dos {
		height: 406px;
	}
}

@media only screen and (max-width: 1436px) {
	.text-dos {
		height: 345px;
	}
}

@media only screen and (max-width: 1384px) {
	.text-dos {
		height: 265px;
	}

	.previewConText {
		width: 37vw;
	}
}

@media only screen and (max-width: 600px) {
	.previewConText {
		width: 30vw;
	}
}

@media only screen and (max-width: 1000px) {
	.marks {
		position: unset;
	}

	.text-dos {
		height: 360px;
	}
}

@media only screen and (max-width: 785px) {
	.text-dos {
		height: 345px;
	}
}

.tp-testconfigs-container {
	background: #f2f4fd;
	box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
	border-radius: 3px;
	padding: 11px 10px;
}
</style>
